var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explore"},[_c('div',{staticClass:"d-none d-md-block mb-10"},[_c('link-cards')],1),_c('asset-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }